const LANGUAGES = [
  {
    code: 'fr',
    label: 'French',
  },
  {
    code: 'en',
    label: 'English',
  },
  {
    code: 'de',
    label: 'German',
  },
  {
    code: 'it',
    label: 'Italian',
  },
  {
    code: 'rm',
    label: 'Romansh',
  },
];

const BRANCHES = [
  {
    label: 'Latest',
    value: 'production',
  },
  {
    label: 'Local',
    value: 'local',
  },
];

const ENVIRONMENTS = [
  {
    title: 'test',
    host: 'il-test.srgssr.ch',
  },
  {
    title: 'stage',
    host: 'il-stage.srgssr.ch',
  },
  {
    title: 'prod',
    host: 'il.srgssr.ch',
  },
  {
    title: 'mmf',
    host: 'play-mmf.herokuapp.com',
  },
  {
    title: 'il-spritesheet-demo',
    host: 'il-spritesheet-demo.herokuapp.com'
  },
  {
    title: 'sam-test',
    host: 'il-test.srgssr.ch/sam'
  },
  {
    title: 'sam-stage',
    host: 'il-stage.srgssr.ch/sam'
  },
  {
    title: 'sam-prod',
    host: 'il.srgssr.ch/sam'
  },
];

const STREAMS = {
  RTS: [
    { steamType: 'vod', title: 'VOD 19h30', type: 'srgssr/urn', src: 'urn:rts:video:10894383' },
    { steamType: 'vodToken', title: 'VOD Token', type: 'srgssr/urn', src: 'urn:rts:video:6255456' },
    { steamType: 'livedvr', title: 'Live DVR', type: 'srgssr/urn', src: 'urn:rts:video:1967124' },
    {
      steamType: 'livedrmdvr',
      title: 'Live DRM DVR',
      type: 'srgssr/urn',
      src: 'urn:rts:video:3608506',
    },
    { steamType: 'aod', title: 'AOD', type: 'srgssr/urn', src: 'urn:rts:audio:9348470' },
    {
      steamType: 'liveaudio',
      title: 'Live Audio',
      type: 'srgssr/urn',
      src: 'urn:rts:audio:3262363',
    },
  ],
  SRF: [
    {
      steamType: 'livedrm',
      title: 'Live DRM',
      type: 'srgssr/urn',
      src: 'urn:srf:video:c4927fcf-e1a0-0001-7edd-1ef01d441651',
    },
    {
      src: 'urn:srf:video:d6301152-89b9-4081-a058-6f2c586fb008',
      title: 'VOD Standard SD HDS',
    },
    {
      src: 'urn:srf:vis:video:B0000000-0000-0000-0000-000000000001',
      title: 'VOD Premium SD HDS',
    },
    {
      src: 'urn:srf:vis:video:40ca0277-0e53-4312-83e2-4710354ff53e',
      title: 'RTMP H264 HQ/MQ/LQ',
    },
    {
      src: 'urn:srf:vis:video:cb4742dc-5ca3-4eb4-a0a7-e2a1a31d03cc',
      title: 'Blocked Sgement',
    },
    {
      src: 'urn:srf:vis:video:43cd2250-07f6-4e52-b354-06046042ec5a',
      title: 'Blocked Video',
    },
    {
      src: 'urn:srf:video:1dfc7f44-7400-4782-b973-e58035642f0b',
      title: 'Subtitles Full Length',
    },
    {
      title: 'AOD (RTMP / HDS / HLS)',
      src: 'urn:srf:audio:ff06aa42-b21d-49eb-b027-9f88ce8c4929',
    },
  ],
  RSI: [
    {
      title: 'VOD ww',
      src: 'urn:rsi:video:1511530',
    },
    {
      title: 'VOD ch',
      src: 'urn:rsi:video:820426',
    },
    {
      title: 'Display Error',
      src: 'urn:rsi:video:1132444',
    },
    {
      title: 'AOD HQ/MQ (HTTP: OGG, MP3)',
      src: 'urn:rsi:audio:4126778',
    },
  ],
  SWI: [
    {
      title: 'VOD ww',
      src: 'urn:swi:video:38741008',
    },
  ],
};

const SIZES = ['default', 'tiny', 'xsmall', 'small', 'medium', 'large'];

const DEFAULT = {
  URN: 'urn:rts:video:10719425',
  env: 'il.srgssr.ch',
  lang: 'fr',
  branch: 'production',
  ratio: 1,
  size: 'default',
  castAppId: '1AC2931D',
};

const RATIOS = [
  {
    format: '18:9',
  },
  {
    format: '16:9',
  },
  {
    format: '9:16',
  },
  {
    format: '4:3',
  },
  {
    format: '1:1',
  },
];

const BUCKET = 'letterbox-web.srgssr.ch';

export { LANGUAGES, BRANCHES, STREAMS, ENVIRONMENTS, DEFAULT, RATIOS, BUCKET, SIZES };
